import styled from 'styled-components'

export const ALertHeaderText = styled.div`
  font-size: 20px;
  line-height: 32px;
  color: rgba(50, 50, 93, 0.7);
`

export const AlertText = styled.div`
  font-size: 20px;
  line-height: 28px;
  color: #F01631;
`



// WEBPACK FOOTER //
// src/routes/Domain/styles.js